import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface AuthFormIntroProps {
  title: ReactNode
  description?: ReactNode
  className?: string
  titleClassName?: string
  descriptionClassName?: string
  as?: 'h1' | 'h2'
}

export function AuthFormIntro({
  title,
  description,
  className,
  titleClassName,
  descriptionClassName,
  as = 'h1',
}: AuthFormIntroProps) {
  const TitleTag = as

  return (
    <div className={cn('space-y-2 text-left', className)}>
      <TitleTag className={cn('text-2xl font-semibold tracking-tight text-foreground', titleClassName)}>
        {title}
      </TitleTag>
      {description ? (
        <p className={cn('text-sm leading-6 text-muted-foreground', descriptionClassName)}>
          {description}
        </p>
      ) : null}
    </div>
  )
}
